<template>
  <v-container class="body">
    <v-flex style="width: 100%; height: 100%; flex: auto; flex-flow: column">
      <div class="firstRow">
        <div style="margin-top:2%">
          <v-row
            ><v-autocomplete
              class="graph-selector"
              :items="chartList"
              label="Gráfico"
              style="padding-left: 30px"
              v-model="selectedChart"
              @change="updateGraph"
            ></v-autocomplete>
            <div v-if="loading">
              <v-progress-circular
                indeterminate
                class="loading"
                color="primary"
              >
                Cargando
              </v-progress-circular>
            </div>
            <v-chart style="width: 60%" class="chart" :option="options" />
          </v-row>
        </div>
        <!--  -->
      </div>
      <div class="secondRow">
        <div class="ant-row ant-row-space-around" style="padding: 70px 10%">
          <div class="ant-col ant-col-sm-15 ant-col-lg-5">
            <div class="ant-row ant-row-end ant-row-top">
              <div
                class="ant-col ant-col-sm-12 ant-col-lg-24"
                style="padding: 10px; text-align: right"
              ></div>
              <div class="ant-col ant-col-lg-18 ant-col-xl-16">
                <h2
                  class="ant-typography"
                  style="
                    white-space: pre-line;
                    margin-left: 5%;
                    padding-bottom: 5%;
                    margin-top: -2%;
                    font-size: xx-large;
                  "
                >
                  Que es el modelo de reconocimiento y caracterización de
                  registros administrativos
                </h2>
                <div style="padding-right: 60px; margin-top: -2.5%">
                  <span class="ant-typography" style="font-size: 16px"
                    >El Modelo de reconocimiento y caracterización de registros
                    administrativos es un sistema informático fácil de utilizar
                    que permite el acopio, caracterización y evaluación de
                    calidad de los Registros Administrativos que producen las
                    instituciones públicas y otros productores de estadística
                    del Sistema Estadístico Nacional (SEN). Con el propósito de
                    potenciar su aprovechamiento estadístico mediante la
                    identificación de posibles acciones de mejora que procura su
                    fortalecimiento.<br /><br />La identificación,
                    caracterización y evaluación de calidad de los Registros
                    Administrativos se realiza fundamentalmente a partir de una
                    adaptación nacional del Cuestionario para Evaluar la Calidad
                    de los Registros Administrativos (CECRA) desarrollado por
                    los países de la Comunidad Andina y financiado por el
                    BID.<br /><br />Este sistema se enmarca dentro del conjunto
                    de estrategias y esfuerzos que implementa la Oficina
                    Nacional de Estadística (ONE) para fortalecer la producción
                    y difusión de estadísticas basadas en registros
                    administrativos, a la vez que promueve la cooperación con
                    los productores y facilita a los ciudadanos realizar
                    consultas y descargar la ficha resumen con información de
                    cada registro administrativo del catálogo.</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-col
        class=""
        style="
          margin: 0px;
          padding: 50px 10%;
          background-color: rgb(255, 255, 255);
        "
      >
        <div
          class="ant-col ant-col-24"
          style="padding-left: 14px; padding-right: 14px"
        >
          <div class="ant-row ant-row-center ant-row-middle">
            <h3
              class="ant-typography"
              style="white-space: pre-line; text-align: center; margin-left: 5%"
            >
              Como funciona el modelo de reconocimiento y caracterización de
              registros administrativos
            </h3>
          </div>
        </div>
        <div
          class="ant-col ant-col-24"
          style="padding-left: 14px; padding-right: 14px; margin: 30px 0px"
        >
          <div class="ant-row ant-row-center ant-row-middle">
            <v-row align="center">
              <div
                class="
                  ant-col ant-col-sm-6 ant-col-md-8 ant-col-xl-6 ant-col-xxl-4
                "
              >
                <div class="ant-image" style="width: 200px">
                  <img
                    class="ant-image-img"
                    src="@/assets/complete-forms.svg"
                  />
                </div>
              </div>

              <div class="ant-col ant-col-sm-12 ant-col-xl-10 right-text">
                <h5 class="ant-typography" style="font-size: x-large">
                  Completar los formularios
                </h5>
                <span
                  class="ant-typography"
                  style="text-align: justify; font-size: medium"
                >
                  Las instituciones y/o organizmos nacionales completan los
                  formularios de de registros administrativos.
                </span>
              </div>
            </v-row>
          </div>
        </div>
        <div
          class="ant-col ant-col-24"
          style="padding-left: 14px; padding-right: 14px; margin: 30px 0px"
        >
          <div class="ant-row ant-row-center ant-row-middle">
            <v-row align="center"
              ><div
                class="
                  ant-col ant-col-sm-6 ant-col-md-8 ant-col-xl-6 ant-col-xxl-4
                "
              >
                <div class="ant-image" style="width: 200px">
                  <img class="ant-image-img" src="@/assets/analitics.svg" />
                </div>
              </div>
              <div class="ant-col ant-col-sm-12 ant-col-xl-10 right-text">
                <h5 class="ant-typography" style="font-size: x-large">
                  Analizar los formularios suministrados
                </h5>
                <span
                  class="ant-typography"
                  style="text-align: justify; font-size: medium"
                >
                  Con ayuda del sistema analizamos estos registros
                  administrativo para proveer diferentes facilidades para el
                  publico nacional.
                </span>
              </div>
            </v-row>
          </div>
        </div>
        <div
          class="ant-col ant-col-24"
          style="padding-left: 14px; padding-right: 14px; margin: 30px 0px"
        >
          <v-row align="center">
            <div class="ant-row ant-row-center ant-row-middle">
              <div
                class="
                  ant-col ant-col-sm-6 ant-col-md-8 ant-col-xl-6 ant-col-xxl-4
                "
              >
                <div class="ant-image" style="width: 200px">
                  <img class="ant-image-img" src="@/assets/review.svg" />
                </div>
              </div>
              <div class="ant-col ant-col-sm-12 ant-col-xl-10 right-text">
                <h5 class="ant-typography" style="font-size: x-large">
                  Proveer de formularios estadisticos
                </h5>
                <span class="" style="text-align: justify; font-size: medium">
                  Ya los formularios analizados y validados, en la sección de
                  reportes se contamplan los reportes estadisticos con tablas y
                  graficos (para instituciones registradas) y datos generales
                  para el publico.
                </span>
              </div>
            </div>
          </v-row>
        </div>
      </v-col>
    </v-flex>
  </v-container>
</template>

<script>
import { getcountersPublics } from "@/utils/apiRequest";
import { getCountInData, setupGraph } from "@/utils/utils";
// getCookie
export default {
  data() {
    return {
      loading: true,
      //
      formsCount: 0,
      rejectedCount: 0,
      approvedCount: 0,
      publishedCount: 0,
      sectorsCount: new Map(),
      domainsCount: new Map(),
      subDomainsCount: new Map(),
      institutionsCount: new Map(),
      selectedChart: "dominios",
      //
      chartList: [],
      combinations: new Map(),
      ans: {},
      chartData: {
        series: [0, 0, 0, 0],
        labels: ["Aceptados", "Rechazados", "Publicados", "Enviados"],
        colors: ["#15CA00", "#EA2900", "#0718E3", "#DEE800"],
      },
      options: {},
    };
  },
  methods: {
    updateGraph(value) {
      getCountInData(this, value);
      let data = this.combinations.get(value);

      this.options = data;
    },
  },
  watch: {},

  async mounted() {
    if (window.location.hash == "#logged" || window.location.hash == "#out") {
      window.location = window.location + "/";
      window.location.reload();
    }

    let response = await getcountersPublics();
    if (response.status == 200) {
      this.formsCount = response.data.totalCount;
      this.rejectedCount = response.data.rejected;
      this.approvedCount = response.data.approved;
      this.sectorsCount = Object.entries(response.data.sectors);
      this.domainsCount = Object.entries(response.data.domains);
      this.subDomainsCount = Object.entries(response.data.subdomains);
      this.institutionsCount = Object.entries(response.data.organizations);
      this.publishedCount = response.data.published;
      setupGraph(this, "public");
      this.updateGraph("dominios");
    }

    this.loading = false;
  },
};
</script>

<style scoped lang="css">
.loading {
  position: absolute;
  left: 50%;
  margin: 15% 0 0 0;
}
.ant-image-img {
  width: 100%;
  height: 100%;
}

.ant-typography {
  color: rgba(0, 0, 0, 0.85);
  word-break: normal;
}

.ant-row,
.ant-row:after,
.ant-row:before {
  display: flex;
}

.ant-row {
  flex-flow: row wrap;
}

.ant-typography h5,
h5.ant-typography {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
}

.ant-typography h3,
h3.ant-typography {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 24px;
  line-height: 1.35;
}

.ant-typography strong {
  font-weight: 600;
}

.firstRow {
  height: 50%;
  min-height: 50%;
}

.right-text {
  margin-left: 10%;
  flex: 0 0 50%;
}

.secondRow {
  background-color: #f1f0ff;
  margin-top: 1%;
  height: 50%;
}

.formsCountDiv {
  vertical-align: 50%;
}

/* 5+20% = margin 0 0 0 25 */
.chart {
  margin: 0 0 0 5%;
  width: 80%;
  height: 40rem;
}

.graph-selector {
  max-width: 20%;
}

.body {
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji,
    Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-variant: tabular-nums;
  line-height: 1.5715;
  background-color: #fff;
  font-feature-settings: "tnum", "tnum";
}
</style>